import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import "./LoadingContainerElement.scss";

const LoadingContainerElement = () => (
  <div className="loading-container">
    <Image
      className="loader-animation-gif"
      name="preloader"
      ext="gif"
      alt=""
      title=""
    />
  </div>
);

export default LoadingContainerElement;
